import { connect } from "react-redux";
import { Slider as Component } from "./Slider";
import { selectNewSequence } from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectSequence: (params) => {
      dispatch(selectNewSequence(params));
    },
  };
}

export const Slider = connect(mapStateToProps, mapDispatchToProps)(Component);
